export const PLAYER_AVATAR = "🤨";
export const PLAYER_AVATAR_SICK = "🥵";
export const PLAYER_AVATAR_DEAD = "💀";
export const GRUNT_AVATAR = "👽";
export const FIRE_AVATAR = "🔥";

// min is 2 for movement
export const GRUNT_MAX_SPEED = 2;
export const DAMAGE_AREA_SIZE = 5;

export const DEFAULT_GRUNT_SIZE = 30;
export const DEFAULT_GRUNT_DAMAGE = 25;
export const DEFAULT_GRUNT_STRIDE = 7;

export const ENEMY_INCREMENT_PER_STAGE = 1;
export const ENEMY_INITIAL_COUNT = 1;
export const INITIAL_STAGE = 0;